export default __webpack_public_path__ + "static/media/hayen.cb56eaf4.jpg";